import { useLayoutEffect } from 'react';

type BottomComposerListener = (activeComposerCount: number) => void;

let activeComposerCount = 0;
const listeners = new Set<BottomComposerListener>();

const notify = () => {
  listeners.forEach(listener => listener(activeComposerCount));
};

/**
 * Announces a chat composer pinned to the bottom edge of the viewport, so the
 * floating support button can step out of its way. Returns the unregister.
 */
export const registerBottomComposer = () => {
  activeComposerCount += 1;
  notify();

  return () => {
    activeComposerCount = Math.max(0, activeComposerCount - 1);
    notify();
  };
};

export const subscribeToBottomComposers = (listener: BottomComposerListener) => {
  listeners.add(listener);
  listener(activeComposerCount);

  return () => {
    listeners.delete(listener);
  };
};

export const useBottomComposerRegistration = (isPinnedToBottom: boolean) => {
  useLayoutEffect(() => {
    if (!isPinnedToBottom) return;

    return registerBottomComposer();
  }, [isPinnedToBottom]);
};
